import {ComputerDesktopIcon, DevicePhoneMobileIcon} from '@heroicons/react/24/outline';
import {useChangeParams, useEditorDevice} from 'hooks';
import {classNames} from 'utils';

const DEVICES = [
  {name: 'desktop', icon: ComputerDesktopIcon},
  {name: 'mobile', icon: DevicePhoneMobileIcon},
];

interface IProjectDeviceToggleProps {}

const ProjectDeviceToggle = ({}: IProjectDeviceToggleProps) => {
  const device = useEditorDevice();
  const {handleChangeParams} = useChangeParams();
  return (
    <div className="flex border border-slate-300 rounded-md divide-x-1 divide-slate-300 shadow-xs overflow-hidden">
      {DEVICES.map(({name, icon: Icon}) => {
        const current = name === device;
        return (
          <button
            key={name}
            type="button"
            onClick={() => handleChangeParams({device: name})}
            className={classNames(
              current ? 'bg-primary text-white dark:text-white' : 'hover:bg-primary text-slate-500 dark:text-darkText hover:text-white',
              'group flex justify-center items-center py-1.5 px-2.5 cursor-pointer',
            )}>
            <Icon className="size-6" />
          </button>
        );
      })}
    </div>
  );
};

export default ProjectDeviceToggle;
